export const roles = [
  { text: 'Kies een rol...', value: null, disabled: true },
  { text: 'Admin', value: 'admin' },
  { text: 'Provinciaal Campagneleider', value: 'p-campaign-manager' },
  { text: 'Campagneleider', value: 'campaign-manager' },
  { text: 'Vrijwilliger', value: 'volunteer' }
];

export default roles;